import React, { createContext, useContext, useState, useCallback } from 'react';
import { isEqual, isFunction } from 'lodash';
import { initialFilter, initialProduct } from './ProductsUIHelpers';

const ProductsUIContext = createContext();

export function useProductsUIContext() {
  return useContext(ProductsUIContext);
}

export const ProductUIConsumer = ProductsUIContext.Consumer;

export function ProductsUIProvider({ ProductsUIEvents, children }) {
  const [createdProduct, setCreatedProductBase] = useState(initialProduct);
  const [productForView, setProductForViewBase] = useState(initialProduct);
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback(
    (nextQueryParams) => {
      setQueryParamsBase((prevQueryParams) => {
        if (isFunction(nextQueryParams)) {
          nextQueryParams = nextQueryParams(prevQueryParams);
        }
        if (isEqual(prevQueryParams, nextQueryParams)) {
          return prevQueryParams;
        }
        return nextQueryParams;
      });
      console.log('ProductsUIProvider.setQueryParams', queryParams);
    },
    [queryParams]
  );

  const setCreatedProduct = useCallback((nextCreatedProduct) => {
    setCreatedProductBase((prevCreatedProduct) => {
      if (isFunction(nextCreatedProduct)) {
        nextCreatedProduct = nextCreatedProduct(prevCreatedProduct);
      }
      if (isEqual(prevCreatedProduct, nextCreatedProduct)) {
        return prevCreatedProduct;
      }
      return nextCreatedProduct;
    });
  }, []);

  const setProductForView = useCallback((nextProductForView) => {
    setProductForViewBase((prevProductForView) => {
      if (isFunction(nextProductForView)) {
        nextProductForView = nextProductForView(prevProductForView);
      }
      if (isEqual(prevProductForView, nextProductForView)) {
        return prevProductForView;
      }
      return nextProductForView;
    });
  }, []);

  const value = {
    queryParams,
    createdProduct,
    productForView,
    setQueryParams,
    setCreatedProduct,
    setProductForView,
    initialProduct,
    openViewProductDialog: ProductsUIEvents.openViewProductDialog,
    openCreateProductDialog: ProductsUIEvents.openCreateProductDialog,
    openDeleteProductDialog: ProductsUIEvents.openDeleteProductDialog,
  };

  return (
    <ProductsUIContext.Provider value={value}>
      {children}
    </ProductsUIContext.Provider>
  );
}
